import { Link } from "react-router-dom";
import CharacterCard from "@/components/feature/CharacterCard";
import SectionHeading from "@/components/feature/SectionHeading";
import { characters } from "@/mocks/siteData";

export default function CharactersSection() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <SectionHeading
          eyebrow="主要人物"
          title="先把洞洞杂货铺里的人认全"
          desc="从新任店主到村里的熟面孔，再到来历不明的隔壁邻居——漫画的主要人物关系，这里一页铺开。"
        />
        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {characters.slice(0, 3).map((c) => (
            <CharacterCard key={c.id} character={c} />
          ))}
        </div>
        <div className="mt-10 text-center">
          <Link
            to="/characters"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-5 py-2.5 text-sm font-bold text-primary-700 transition-colors hover:bg-primary-50"
          >
            查看全部角色介绍
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}